<template>
  <div class="head-container">
    <div class="content">
      <div class="title">{{ info.title }}</div>
      <div class="info">{{ info.info }}</div>
    </div>
    <slot class="slot"></slot>
  </div>
</template>

<script>
export default {
  name: "HeadView",
  props: ["info"],
};
</script>

<style lang="scss">
.head-container {
  height: 80px;
  padding: 10px 15px;
  border-bottom: #ccc solid 1px;
  background-color: white;
  display: flex;
  align-items: center;

  .content {
    flex: 1;

    .title {
      font-size: 20px;
      font-weight: bold;
    }
    .info {
      font-size: 13px;
      margin-top: 20px;
      color: #333;
    }
  }
}
</style>
